import React, { useEffect, useState } from 'react'
import { Copyright, CRight, FooterContainer, Media, Row, SFooter, MediaList, TextList, PreFooter, PreList, PreElement, FooterTitle, FooterCopyright } from './Footer.elements'
import {FaDiscord, FaYoutube} from "react-icons/fa";
import {SiTelegram} from "react-icons/si";
import {MdEmail} from "react-icons/md";

const Footer = () => {
    
  const [data, setData] = useState(null);

  const getData = () => {
    fetch('settings.json'
      , {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }
    ).then(function(response){
      return response.json();
    })
    .then(function(myJson) {
      console.log(myJson)
      setData(myJson.Components);
    });
  }
  useEffect(() => {
    getData()
  }, [])

    return (
        <React.Fragment>
            {
                data && 
                    <React.Fragment>
                        <PreFooter>
                            <PreList>
                                <PreElement to="/home">Home</PreElement>
                                <PreElement to="/skills">Skills</PreElement>
                                <PreElement to="/portfolio">Portfolio</PreElement>
                                <PreElement to="/prices">Prices</PreElement>
                                <PreElement to="/contacts">Contacts</PreElement>
                            </PreList>
                        </PreFooter>
                        <SFooter>
                            <FooterContainer>
                                <FooterTitle>{data.Footer.Title}</FooterTitle>
                                <FooterCopyright>{data.Footer.Copyright}</FooterCopyright>
                            </FooterContainer>
                            <Media>
                                    <ul>
                                        <MediaList href={data.Socials.discord}><FaDiscord color="#4F4F50" size="18px"/></MediaList>
                                        <MediaList href={data.Socials.youtube}><FaYoutube color="#4F4F50" size="18px"/></MediaList>
                                        <MediaList href={data.Socials.telegram}><SiTelegram color="#4F4F50" size="18px"/></MediaList>
                                        <MediaList href={data.Socials.email}><MdEmail color="#4F4F50" size="18px"/></MediaList>
                                    </ul>
                                </Media>
                                <Copyright>{data.Footer.BottomText}</Copyright>
                        </SFooter>
                    </React.Fragment>
            }
            
        </React.Fragment>
    )
}

export default Footer
